<template>
  <div>
    <el-dialog
      :title="privilegeCardInfo.name + '兑换记录'"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      width="80%"
    >
      <!--search from-->
      <el-form
        ref="formRef"
        :inline="true"
        size="mini"
        :rules="formRules"
        :model="searchForm"
        class="demo-form-inline"
      >
        <el-form-item label="用户">
          <el-input
            v-model="searchForm.keyword"
            placeholder="支持用户名/手机号"
            clearable
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="兑换码">
          <el-input
            v-model="searchForm.code"
            placeholder="请输入兑换码"
            clearable
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否领取">
          <el-select
            v-model="searchForm.receive"
            placeholder="请选择"
            clearable
            size="mini"
          >
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="领取时间">
          <el-date-picker
            v-model="searchForm.receiveBeginTime"
            type="date"
            placeholder="选择日期"
            style="width:150px"
            size="mini"
            clearable
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          ~
          <el-date-picker
            v-model="searchForm.receiveEndTime"
            type="date"
            placeholder="选择日期"
            style="width:150px"
            size="mini"
            clearable
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="创建时间">
          <el-date-picker
            v-model="searchForm.beginTime"
            type="date"
            placeholder="选择日期"
            style="width:150px"
            size="mini"
            clearable
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          ~
          <el-date-picker
            v-model="searchForm.endTime"
            type="date"
            placeholder="选择日期"
            style="width:150px"
            size="mini"
            clearable
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="loadPage(1)"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <!--btn-->
      <div class="btn">
        <el-button
          type="success"
          size="mini"
          icon="el-icon-plus"
          @click="showGenerateDialog"
          >生成兑换码</el-button
        >
      </div>
      <!--table-->
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        size="mini"
      >
        <!--index-->
        <el-table-column
          type="index"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="code"
          label="兑换码"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="receiveName"
          label="是否领取"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="receiveTime"
          label="领取时间"
          align="center"
        ></el-table-column>
        <el-table-column label="领取者" align="center">
          <template slot-scope="scope">
            <span
              >{{ scope.row.subscriberName || "" }} /
              {{ scope.row.subscriberPhone || "" }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="created"
          label="创建时间"
          align="center"
        ></el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchForm.total"
        size="mini"
      >
      </el-pagination>
    </el-dialog>

    <!--dialog-->
    <el-dialog
      title="生成"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleGenerateClose"
      width="30%"
      center
      v-loading="generateLoading"
    >
      <el-form :inline="true" size="mini" class="demo-form-inline">
        <el-form-item label="生成数量">
          <el-input-number v-model="generateNum" :min="1"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="handleGenerate"
          >生成</el-button
        >
        <el-button size="mini" @click="handleGenerateClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  bizPrivilegeCardCodePage,
  bizPrivilegeCardCodeSave
} from "@/api/privilege";

/**
 * 兑换记录
 *
 */
export default {
  name: "ExchangeCodeRecord",
  data() {
    return {
      visible: false,
      loading: false,
      stateOptions: [
        {
          label: "未领取",
          value: 0
        },
        {
          label: "已领取",
          value: 1
        }
      ],
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      formRules: {},
      tableData: [],
      privilegeCardInfo: {},
      dialogVisible: false,
      generateLoading: false,
      generateNum: 1
    };
  },
  methods: {
    handleClose() {
      this.visible = false;
    },
    open(info) {
      this.privilegeCardInfo = info;

      this.visible = true;
      this.loadPage(1);
    },
    loadPage(page) {
      if (page) {
        this.searchForm.pageNum = page;
      }
      this.searchForm.cardId = this.privilegeCardInfo.id;
      this.loading = true;
      bizPrivilegeCardCodePage(this.searchForm)
        .then(resp => {
          if (resp.data.status == 100) {
            this.tableData = resp.data.results.list;
            this.searchForm.total = resp.data.results.total;
          } else {
            this.$message({
              message: resp.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.loadPage();
    },
    handleCurrentChange(page) {
      this.searchForm.pageNum = page;
      this.loadPage();
    },
    showGenerateDialog() {
      this.dialogVisible = true;
      this.generateNum = 1;
    },
    handleGenerateClose() {
      this.dialogVisible = false;
    },
    handleGenerate() {
      // 二次确认
      this.$confirm("是否确认生成?", "提示", {
        confirmButtonText: "确定"
      })
        .then(() => {
          this._generate();
        })
        .catch(() => {});
    },
    _generate() {
      this.generateLoading = true;
      bizPrivilegeCardCodeSave(this.privilegeCardInfo.id, this.generateNum)
        .then(resp => {
          if (resp.data.status == 100) {
            this.$message({
              message: "生成成功",
              type: "success"
            });
            this.loadPage();
            this.handleGenerateClose();
          } else {
            this.$message({
              message: resp.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.generateLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.btn {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// exchangeCode.vue?29dfc152